import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/aceites/etiqueta_señalizador.webp")